import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { competencies } from '../data/competencies';
import { Reveal } from './Reveal';
const ease = [0.23, 1, 0.32, 1] as const;
export function Competencies() {
  const [activeId, setActiveId] = useState(competencies[0].id);
  const active = competencies.find(c => c.id === activeId) ?? competencies[0];
  return <section id="competencies" className="bg-paper py-20 lg:py-24" data-id="element-29" data-mp="2nznzwk0h4i6g">
      <div className="mx-auto max-w-shell px-6 lg:px-10" data-id="element-30" data-mp="2o1ic99xoj1yx">
        <Reveal data-id="element-31" data-mp="2sxfvbo0bumfe">
          <h2 className="max-w-2xl font-display text-3xl font-light leading-[1.15] text-navy" data-id="element-32" data-mp="2swxoxyjyartr">
            Four pillars behind every portfolio I have scaled
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-px border border-navy/10 bg-navy/10 lg:grid-cols-12" data-id="element-33" data-mp="31xvwurxifjhm">
          {/* Selector list */}
          <ul className="bg-white lg:col-span-5" data-id="element-34" data-mp="13lngvb3l3t5t">
            {competencies.map(item => {
            const isActive = item.id === active.id;
            return <li key={item.id} className="border-b border-navy/10 last:border-b-0" data-id="element-35" data-mp="2nbj29cyq9fm9">
                  <button type="button" onClick={() => setActiveId(item.id)} aria-expanded={isActive} aria-controls="competency-detail" className={`group flex w-full items-start gap-5 px-6 py-7 text-left transition-colors duration-150 ease-out lg:px-8 ${isActive ? 'bg-navy text-paper' : 'text-navy hover:bg-paper'}`} data-id="element-36" data-mp="2iizn4bke6cfc">
                    <span className={`mt-1 font-display text-sm ${isActive ? 'text-gold-soft' : 'text-gold'}`} data-id="element-37" data-mp="2wammik9ms12c">
                      {item.index}
                    </span>
                    <span data-id="element-38" data-mp="1ktwd6s9wut4i">
                      <span className="block font-display text-xl font-light leading-snug" data-id="element-39" data-mp="1fwo21bn6jpcr">
                        {item.title}
                      </span>
                      <span className={`mt-2 block text-[13px] leading-relaxed ${isActive ? 'text-white/65' : 'text-steel'}`} data-id="element-40" data-mp="7vmavjddpwdi">
                        {item.summary}
                      </span>
                    </span>
                  </button>
                </li>;
          })}
          </ul>

          {/* Detail panel */}
          <div id="competency-detail" className="bg-paper px-6 py-10 lg:col-span-7 lg:px-12 lg:py-14" data-id="element-41" data-mp="3p6dqjn1gbguc">
            <AnimatePresence mode="wait" data-id="element-42" data-mp="3bg0jro0aq86l">
              <motion.div key={active.id} initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -6
            }} transition={{
              duration: 0.22,
              ease
            }} data-id="element-43" data-mp="3gdjxmmt30iy0">
                <p className="text-[11px] uppercase tracking-overline text-gold" data-id="element-44" data-mp="36ekzhy5y05p9">
                  Pillar {active.index}
                </p>
                <h3 className="mt-5 font-display text-2xl font-light leading-snug text-navy lg:text-3xl" data-id="element-45" data-mp="2ish8ctjsfbws">
                  {active.title}
                </h3>
                <ul className="mt-8 space-y-6" data-id="element-46" data-mp="2wpno0f97suhs">
                  {active.points.map(point => <li key={point} className="flex gap-4 border-t border-navy/10 pt-6" data-id="element-47" data-mp="2ruqktoym9fct">
                      <span aria-hidden="true" className="mt-2 h-px w-6 shrink-0 bg-gold" data-id="element-48" data-mp="35qlxve6c3w8a" />
                      <span className="text-[15px] leading-[1.75] text-steel" data-id="element-49" data-mp="3fihxwurzdwf5">{point}</span>
                    </li>)}
                </ul>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>;
}